/**
 * Wallet vs Roost view — only one grid visible when connected.
 * Disconnected: switcher hidden; wallet panel shows connect empty state.
 */

export function getGalleryView() {
  return document.body.dataset.galleryView === "roost" ? "roost" : "wallet";
}

/**
 * @param {"wallet" | "roost"} view
 */
function setGalleryView(view) {
  document.body.dataset.galleryView = view;

  const panelW = document.getElementById("nft-panel-wallet");
  const panelR = document.getElementById("nft-panel-roost");
  const btnW = document.getElementById("btn-view-wallet");
  const btnR = document.getElementById("btn-view-roost");
  const btnRefresh = document.getElementById("btn-roost-refresh");

  const isWallet = view === "wallet";
  if (panelW) panelW.hidden = !isWallet;
  if (panelR) panelR.hidden = isWallet;

  if (btnW) {
    btnW.classList.toggle("is-active", isWallet);
    btnW.setAttribute("aria-pressed", isWallet ? "true" : "false");
  }
  if (btnR) {
    btnR.classList.toggle("is-active", !isWallet);
    btnR.setAttribute("aria-pressed", !isWallet ? "true" : "false");
  }
  if (btnRefresh) btnRefresh.hidden = isWallet;

  window.dispatchEvent(new CustomEvent("owlex:gallery-view", { detail: { view } }));
}

export function initGallerySwitcher() {
  const switcher = document.getElementById("nft-view-switcher");
  const btnW = document.getElementById("btn-view-wallet");
  const btnR = document.getElementById("btn-view-roost");
  const btnRefresh = document.getElementById("btn-roost-refresh");

  setGalleryView("wallet");

  window.addEventListener("owlex:account", (e) => {
    const addr = e.detail?.address;
    if (switcher) switcher.hidden = !addr;
    if (btnRefresh) btnRefresh.hidden = true;
    if (!addr) {
      setGalleryView("wallet");
    }
  });

  btnW?.addEventListener("click", () => setGalleryView("wallet"));
  btnR?.addEventListener("click", () => setGalleryView("roost"));
}
